module.exports = "<div [ngSwitch]=\"commentType\">\n  <span class=\"text-danger\" *ngSwitchCase=\"'Declined'\">Declined</span>\n  <span class=\"text-success\" *ngSwitchCase=\"'Approved'\">Approved</span>\n  <span class=\"text-danger\" *ngSwitchCase=\"'Tessco_Declined'\">Revision Requested by TESSCO</span>\n  <span *ngSwitchDefault>&nbsp;</span>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/comments/commenter-action/commenter-action.component.html
// module id = ../../../../../src/app/comments/commenter-action/commenter-action.component.html
// module chunks = main